import React, { FC } from 'react'
import styles from '../CollectionDetails.module.scss'
import SALink from 'components/SALink'
import { capitalizeString } from 'lib/helpers'
import CollectionDetailsBreadcrumb from './CollectionDetailsBreadcrumb'
import useQA from 'hooks/useQA'

type CollectionDetailsHeaderProps = {
  title: string
  subCopy: string
  collectionOwnerName: string
  collectionOwnerAvatarUrl: string
  collectionOwnerId: string
  collectionCount: number
  ownerTitle?: string
}

const CollectionDetailsHeader: FC<CollectionDetailsHeaderProps> = ({
  title,
  subCopy,
  collectionOwnerName,
  collectionOwnerAvatarUrl,
  collectionOwnerId,
  collectionCount,
  ownerTitle,
}) => {
  const { testId } = useQA()
  const capitalizedOwnerName = capitalizeString(collectionOwnerName)

  return (
    <div className={styles.headerWrapper}>
      <CollectionDetailsBreadcrumb
        collectionOwnerName={collectionOwnerName}
        collectionOwnerId={collectionOwnerId}
      />

      <div className={styles.headerBox}>
        <div className={styles.headerGrid}>
          <div className={styles.titleBox} {...testId('title-box')}>
            <h1>{title}</h1>
            {Boolean(subCopy) && <p>{subCopy}</p>}
          </div>
        </div>

        <div className={styles.curatedBy} {...testId('curated-by')}>
          <SALink
            href={`/account/profile/${collectionOwnerId}`}
            title={`View profile of ${capitalizedOwnerName}`}
            className={styles.avatarBox}
          >
            <img src={collectionOwnerAvatarUrl} alt={capitalizedOwnerName} />
          </SALink>
          <p>
            {collectionCount} Artworks curated by{' '}
            <SALink
              href={`/account/profile/${collectionOwnerId}`}
              title={`View profile of ${capitalizedOwnerName}`}
              className={styles.ownerName}
            >
              {capitalizedOwnerName}
            </SALink>
            {!!ownerTitle && `, ${ownerTitle}`}
          </p>
        </div>
      </div>
    </div>
  )
}

export default CollectionDetailsHeader
